import type {
  roomRocketConfigInterface,
  roomRocketBannerInterface
} from '@/types/apiType/roomType'
import { apiRoomRocketGetConfig } from '@/api/room'
/** 房间炸弹 */
export const useRocketStore = defineStore({
  id: 'rocket',
  state: () => ({
    /** 炸弹配置 */
    rocketConfig: { blastRocket: {}, conf: {} } as roomRocketConfigInterface,
    /** 是否在爆炸状态 */
    isDetonating: false as boolean,
    /** 爆炸等级 */
    gradeDetonating: 0 as number,
    /** 引爆横幅，爆弹奖励横幅 */
    bannerRocket: [] as roomRocketBannerInterface[]
  }),
  getters: {
    /** 炸弹是否开启 */
    isShowRocket(state): boolean {
      return (
        state.rocketConfig.blastRocket &&
        state.rocketConfig.conf &&
        state.rocketConfig.blastRocket.showEgg &&
        Number(state.rocketConfig.blastRocket.rocketWater) >=
          state.rocketConfig.conf.show &&
        Number(state.rocketConfig.blastRocket.rocketGrade) >= 0 &&
        Number(state.rocketConfig.blastRocket.rocketGrade) < 8
      )
    }
  },
  actions: {
    /**
     * 设置横幅
     * @param  {shift | init | push} type 类型：shift：移除第一项, init：初始化，push：添加data
     */
    setBannerRocket(
      type: 'shift' | 'init' | 'push',
      data?: roomRocketBannerInterface
    ) {
      const publicStore = usePublicStore()
      switch (type) {
        case 'init':
          this.bannerRocket = []
          break
        case 'shift':
          this.bannerRocket.shift()
          break
        case 'push':
          if (data && publicStore.isPageVisible) {
            this.bannerRocket.push(data)
          }
          break
      }
    },

    /** 房间爆弹奖励 */
    onRoomRocketReward(data) {
      const roomStore = useRoomStore()
      if (roomStore.roomId === Number(data.room_id)) {
        this.setBannerRocket('push', data.custom.data)
      }
    },
    /** 房间爆弹清空 */
    onRoomRocketDel(data) {
      this.getConfig()
    },
    /** 房间爆弹流水推送 */
    onRoomRocketDiamond(data) {
      const roomStore = useRoomStore()
      if (roomStore.roomId === Number(data.room_id)) {
        this.rocketConfig.blastRocket = data.custom.data
        if (this.rocketConfig.blastRocket.blastGrade === '-1') {
          this.setIsDetonating(false)
        }
      }
    },
    /** 房间炸弹爆炸 */
    onRoomRocketBlowUp(data) {
      const roomStore = useRoomStore()
      if (roomStore.roomId === Number(data.room_id)) {
        if (
          data.custom.data.roomType === roomStore.roomType &&
          data.custom.data.time
        ) {
          // 炸弹爆炸
          this.gradeDetonating = data.custom.data.grade
          this.setBannerRocket('push', data.custom.data)
          this.setIsDetonating(true)
        }
      }
    },
    /** 设置isDetonating */
    setIsDetonating(is: boolean) {
      this.isDetonating = is
    },
    /** 接口获取配置 */
    getConfig() {
      const roomStore = useRoomStore()
      apiRoomRocketGetConfig({
        sn: 123456,
        roomType: roomStore.roomType,
        roomUid: roomStore.roomUid
      }).then((res) => {
        if (res.code === 200) {
          this.rocketConfig = res.data
        }
      })
    },
    /** 重置数据 */
    resetData() {
      this.rocketConfig = {} as roomRocketConfigInterface
      this.isDetonating = false
      this.gradeDetonating = 0
      this.setBannerRocket('init')
    }
  }
})
